/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { TriggerArgs_ChannelCallback } from "../../trigger_args";

export const protobufPackage = "complimentary_actions";

/**
 * Note(Ayush): this action is meant to be used in close coordination with the action under test
 * It allows us to control the spoof results for a series of photo capture requests, so that we
 * can test the action's robustness for a shorter range of failures, and action's error surfacing
 * for a longer range of failures.
 */
export interface SpoofPhotoResponseActionArgs {
  trigger:
    | TriggerArgs_ChannelCallback
    | undefined;
  /** Index of the trigger on which the action starts spoofing the photo response. */
  spoofStartTriggerIdx: number;
  /**
   * Index of the trigger on which the action stops spoofing the photo response, ending the
   * complimentary action.
   */
  spoofEndTriggerIdx: number;
  /**
   * The photo capture result to use in spoofed responses.
   * Note(Ayush): using an integer here to not bring in user camera enum into mission spec. If this
   * was a production action, I will have created a new enum for this and written a test for
   * mappability to the user camera's enum.
   */
  photoCaptureResult: number;
}

function createBaseSpoofPhotoResponseActionArgs(): SpoofPhotoResponseActionArgs {
  return { trigger: undefined, spoofStartTriggerIdx: 0, spoofEndTriggerIdx: 0, photoCaptureResult: 0 };
}

export const SpoofPhotoResponseActionArgs = {
  encode(message: SpoofPhotoResponseActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.trigger !== undefined) {
      TriggerArgs_ChannelCallback.encode(message.trigger, writer.uint32(10).fork()).ldelim();
    }
    if (message.spoofStartTriggerIdx !== 0) {
      writer.uint32(16).uint32(message.spoofStartTriggerIdx);
    }
    if (message.spoofEndTriggerIdx !== 0) {
      writer.uint32(24).uint32(message.spoofEndTriggerIdx);
    }
    if (message.photoCaptureResult !== 0) {
      writer.uint32(32).uint32(message.photoCaptureResult);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpoofPhotoResponseActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpoofPhotoResponseActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.trigger = TriggerArgs_ChannelCallback.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.spoofStartTriggerIdx = reader.uint32();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.spoofEndTriggerIdx = reader.uint32();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.photoCaptureResult = reader.uint32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpoofPhotoResponseActionArgs {
    return {
      trigger: isSet(object.trigger) ? TriggerArgs_ChannelCallback.fromJSON(object.trigger) : undefined,
      spoofStartTriggerIdx: isSet(object.spoofStartTriggerIdx) ? globalThis.Number(object.spoofStartTriggerIdx) : 0,
      spoofEndTriggerIdx: isSet(object.spoofEndTriggerIdx) ? globalThis.Number(object.spoofEndTriggerIdx) : 0,
      photoCaptureResult: isSet(object.photoCaptureResult) ? globalThis.Number(object.photoCaptureResult) : 0,
    };
  },

  toJSON(message: SpoofPhotoResponseActionArgs): unknown {
    const obj: any = {};
    if (message.trigger !== undefined) {
      obj.trigger = TriggerArgs_ChannelCallback.toJSON(message.trigger);
    }
    if (message.spoofStartTriggerIdx !== 0) {
      obj.spoofStartTriggerIdx = Math.round(message.spoofStartTriggerIdx);
    }
    if (message.spoofEndTriggerIdx !== 0) {
      obj.spoofEndTriggerIdx = Math.round(message.spoofEndTriggerIdx);
    }
    if (message.photoCaptureResult !== 0) {
      obj.photoCaptureResult = Math.round(message.photoCaptureResult);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpoofPhotoResponseActionArgs>, I>>(base?: I): SpoofPhotoResponseActionArgs {
    return SpoofPhotoResponseActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpoofPhotoResponseActionArgs>, I>>(object: I): SpoofPhotoResponseActionArgs {
    const message = createBaseSpoofPhotoResponseActionArgs();
    message.trigger = (object.trigger !== undefined && object.trigger !== null)
      ? TriggerArgs_ChannelCallback.fromPartial(object.trigger)
      : undefined;
    message.spoofStartTriggerIdx = object.spoofStartTriggerIdx ?? 0;
    message.spoofEndTriggerIdx = object.spoofEndTriggerIdx ?? 0;
    message.photoCaptureResult = object.photoCaptureResult ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
